import { mapShareCopyLinkEvent } from 'tag-manager/map_share_copy_link'
import { CopyLinkButton as View } from 'ui-components'
import { baseUrl, getMapLink, useClipboard } from 'utils'
import { useMap } from '~map-preview/states/map'

export const CopyLinkButton = () => {
  const [, onCopyToClipboard] = useClipboard()
  const map = useMap()

  const handleClick = () => {
    mapShareCopyLinkEvent()
    onCopyToClipboard(
      baseUrl() + getMapLink({ mapId: map.id, mapName: map.name })
    )
  }

  return <View onClick={handleClick} />
}
